<template>
    <div
        v-if="visible"
        class="fixed inset-0 z-[3000] flex items-center justify-center bg-black/70 backdrop-blur-sm"
    >
        <div
            class="relative flex items-center justify-center bg-modal-default rounded-[20px] p-6 md:p-8 max-md:w-[80vw] min-w-[320px] md:min-w-[640px] max-w-[90vw] mx-4 shadow-2xl"
            @click.stop
        >
            <button
                @click="handleClose"
                class="absolute top-4 right-4 w-6 h-6 flex items-center justify-center text-white hover:scale-105 transition-all duration-200"
            >
                <img
                    src="@/assets/images/common/_close.webp"
                    alt="close"
                    class="w-[24px]"
                />
            </button>
            <!-- content -->
            <div class="flex flex-col gap-4 w-full">
                <!-- 标题区域 -->
                <div class="flex flex-col gap-1">
                    <span class="text-lg md:text-xl font-semibold text-white">{{
                        t('pricing.choosePaymentMethod')
                    }}</span>
                </div>

                <!-- 商品信息 -->
                <div
                    v-if="goods_data"
                    class="flex items-center justify-between gap-3 rounded-[12px] py-3"
                >
                    <div class="flex items-center gap-2">
                        <img
                            :src="levelIconDisplay"
                            alt="level-icon"
                            class="w-12 h-12"
                        />
                        <div class="flex flex-col">
                            <span
                                class="text-lg md:text-base font-medium text-white truncate max-w-[220px] md:max-w-[320px]"
                            >
                                {{
                                    goods_data?.name || t('pricing.orderGoods')
                                }}
                            </span>

                            <span
                                class="flex justify-start gap-1 items-center text-xs text-text-adad mt-1"
                            >
                                <svg
                                    t="1764229240275"
                                    class="icon"
                                    viewBox="0 0 1024 1024"
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    p-id="2580"
                                    width="16"
                                    height="16"
                                >
                                    <path
                                        d="M888.49 222.686v-31.54l-65.672-0.955h-0.205a465.715 465.715 0 0 1-144.315-31.334c-77.005-31.198-126.294-66.765-126.703-67.107l-39.8-28.672-39.185 28.468c-2.048 1.501-49.903 36.044-126.908 67.31a447.42 447.42 0 0 1-144.52 31.335l-65.877 0.956v378.88c0 87.04 49.834 184.661 137.01 267.81 37.547 35.84 79.258 66.355 120.833 88.2 43.28 22.733 84.24 34.612 118.852 34.612 34.406 0 75.776-12.152 119.603-35.158a547.977 547.977 0 0 0 120.013-87.654 515.209 515.209 0 0 0 96.188-122.88c27.102-49.562 40.823-98.304 40.823-144.999l-0.136-347.204zM510.09 143.428l1.706-1.365 1.775 1.365c5.803 4.165 59.529 41.848 140.356 74.752 79.19 32.086 153.6 35.635 167.663 36.045l2.594 0.068 0.205 315.734c0.137 69.495-42.598 150.186-117.077 221.457C641.57 854.289 563.13 896.478 512 896.478c-23.689 0-55.57-9.899-89.702-27.785a478.822 478.822 0 0 1-105.609-77.278C242.21 720.213 199.475 639.522 199.475 569.89V254.225l2.73-0.136c3.278 0 82.604-1.502 167.664-35.977a739.942 739.942 0 0 0 140.22-74.615v-0.069z"
                                        p-id="2581"
                                        fill="currentColor"
                                    ></path>
                                    <path
                                        d="M713.318 368.64a32.222 32.222 0 0 0-45.329 0L449.195 587.435l-93.184-93.116a32.222 32.222 0 0 0-45.33 0 32.222 32.222 0 0 0 0 45.26l115.85 115.85a32.29 32.29 0 0 0 45.328 0L713.32 413.9a32.222 32.222 0 0 0 0-45.33z"
                                        p-id="2582"
                                        fill="currentColor"
                                    ></path>
                                </svg>
                                {{
                                    t('pricing.paymentInformationIsSafe')
                                }}</span
                            >
                            <span
                                class="flex justify-start gap-1 items-center text-xs text-text-adad mt-1"
                            >
                                <svg
                                    t="1764229460742"
                                    class="icon"
                                    viewBox="0 0 1024 1024"
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    p-id="3829"
                                    width="16"
                                    height="16"
                                >
                                    <path
                                        d="M841.21 224h-56.09v409.37h56.09v286.84a33.66 33.66 0 0 1-49.1 29.91L530.44 814.93a56 56 0 0 0-51.48 0L217.29 950.12a33.65 33.65 0 0 1-49.09-29.9V173.48A112.17 112.17 0 0 1 280.37 61.31H729a112.17 112.17 0 0 1 112.21 112.17zM280.37 117.4a56.08 56.08 0 0 0-56.09 56.08v678.95a16.83 16.83 0 0 0 24.59 14.93l230-119.58a56.13 56.13 0 0 1 51.76 0l229.9 119.58a16.83 16.83 0 0 0 24.59-14.93V173.48A56.08 56.08 0 0 0 729 117.4z m0 0"
                                        p-id="3830"
                                        fill="currentColor"
                                    ></path>
                                    <path
                                        d="M684.17 395.1l63.45-63.46a33.65 33.65 0 0 1 47.59 47.59l-63.45 63.45 63.45 63.46a33.65 33.65 0 0 1-47.59 47.58l-63.45-63.45-63.45 63.45a33.65 33.65 0 1 1-47.59-47.58l63.45-63.46-63.45-63.45a33.65 33.65 0 0 1 47.59-47.59zM807.56 201.53h11.21q22.44 0 22.44 22.42t-22.44 22.44h-11.21q-22.44 0-22.44-22.44t22.44-22.42zM807.56 610.94h11.21q22.44 0 22.44 22.43t-22.44 22.43h-11.21q-22.44 0-22.44-22.43t22.44-22.43z"
                                        p-id="3831"
                                        fill="currentColor"
                                    ></path>
                                </svg>
                                {{
                                    goods_data?.desc ||
                                    t('pricing.cancelSubscription')
                                }}
                            </span>
                        </div>
                    </div>

                    <div class="flex flex-col items-end text-right">
                        <span
                            class="text-lg md:text-2xl font-bold text-[#F5F2F0]"
                        >
                        </span>
                    </div>
                </div>

                <!-- 支付方式列表 -->
                <div
                    v-for="item in goods_data?.payment_types"
                    :key="item.id"
                    class="relative flex justify-between items-center gap-3 bg-tool-side rounded-[12px] px-4 py-3 border cursor-pointer transition-all duration-200"
                    :class="
                        item === selectedPaymentType
                            ? 'border-active-border '
                            : ' border-white/10 hover:border-white/30 '
                    "
                    @click="handleSelectPayType(item)"
                >
                    <div class="flex items-center gap-3">
                        <img
                            :src="payLogoEnums[item]?.logo"
                            alt="pay logo"
                            class="w-7 h-7 rounded-full bg-black/20"
                        />
                        <div class="flex flex-col">
                            <span
                                class="text-sm md:text-base font-medium text-white"
                            >
                                {{ payLogoEnums[item]?.name || item }}
                            </span>
                            <span
                                v-if="payLogoEnums[item]?.desc"
                                class="text-[11px] md:text-xs text-text-adad"
                            >
                                {{ payLogoEnums[item]?.desc }}
                            </span>
                        </div>
                    </div>

                    <div
                        v-if="item === selectedPaymentType"
                        class="flex items-center gap-1 text-[11px] md:text-xs text-[#99F768]"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            class="w-5 h-5"
                        >
                            <path
                                d="M16.667 5L7.5 14.167 3.333 10"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </div>
                </div>

                <!-- 操作按钮 -->
                <div
                    class="flex flex-col justify-center items-center md:flex-row gap-3 mt-2 md:mt-4"
                >
                    <button
                        class="flex-1 py-2 px-4 truncate flex items-center justify-center gap-2 max-w-[300px] min-w-[200px] h-[44px] rounded-[10px] font-semibold text-sm md:text-base hover:scale-105 transition-all duration-300"
                        :class="
                            can_confirm_pay
                                ? 'bg-create-btn text-black hover:brightness-110'
                                : 'bg-create-btn/40 text-black/70 cursor-not-allowed'
                        "
                        :disabled="!can_confirm_pay"
                        @click="handleConfirmPay"
                    >
                        <el-icon v-if="pay_loading" class="animate-spin"
                            ><Loading
                        /></el-icon>
                        <span>
                            {{
                                pay_loading
                                    ? t('pricing.payLoading')
                                    : t('pricing.payConfirm')
                            }}
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from '~/composables/useI18n'
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { emitter, emitOrderGoods } from '~/utils/emitter'
import { useUserStore } from '~/stores/user'
import { getRechargeResultApi } from '~/api/common'
import { useRoute } from '#imports'
import { useToolsHooks } from '~/utils/useHooks'

const userStore = useUserStore()
const visible = ref<boolean>(false)
const route = useRoute()
const { levelIcon } = useToolsHooks()

const { t } = useI18n()

const payLogoEnums: any = computed(() => {
    return {
        creem_subs_h5: {
            logo: 'https://static.weryai.com/growth/image/9e4a85ca37816fb974a8bd5c88fed7f0.webp',
            name: 'Creem',
            desc: t('pricing.supperMainbank'),
        },
        air_wallex_subs_h5: {
            logo: 'https://static.weryai.com/growth/image/5ffb45ad2ad8321cdd4bf7935383a5d5.svg',
            name: 'Air Wallex',
            desc: t('pricing.globalCreditCard'),
        },
        creem_h5: {
            logo: 'https://static.weryai.com/growth/image/9e4a85ca37816fb974a8bd5c88fed7f0.webp',
            name: 'Creem',
            desc: t('pricing.supperMainbank'),
        },
        air_wallex_h5: {
            logo: 'https://static.weryai.com/growth/image/5ffb45ad2ad8321cdd4bf7935383a5d5.svg',
            name: 'Air Wallex',
            desc: t('pricing.globalCreditCard'),
        },
    }
})

const levelIconDisplay = computed(() => {
    const commonLevel = ['PLAN_ENTRY', 'PLAN_BASIC', 'PLAN_PRO']
    const subscription_type = goods_data.value?.subscription_type
    if (!subscription_type)
        return 'https://static.weryai.com/growth/image/db753474044cbfb2a3fa959667c02bd9.webp'
    return levelIcon[commonLevel.indexOf(subscription_type || 0)]
})

/**
 * 处理关闭弹窗
 */
const handleClose = () => {
    visible.value = false
}

// 当前待支付的商品信息
const goods_data = ref<any | null>(null)

// 当前选中的支付方式
const selectedPaymentType = ref<string | null>(null)

const can_confirm_pay = computed(() => {
    return selectedPaymentType.value && !pay_loading.value
})

const showVisible = (data: any) => {
    console.log(data)

    visible.value = true
    goods_data.value = data
    // 默认选中第一个可用支付方式
    selectedPaymentType.value = data?.payment_types?.[0] || null
}

// 选择支付方式
const handleSelectPayType = (payType: string) => {
    selectedPaymentType.value = payType
}

const isClient = ref(false)

onMounted(async () => {
    if (typeof window !== 'undefined') {
        try {
            const { dotSpinner } = await import('ldrs')
            dotSpinner.register()
            // 确保注册完成后再设置 isClient，避免组件在注册前渲染
            isClient.value = true
        } catch (error) {
            console.error('Failed to load ldrs:', error)
            // 即使加载失败也设置为 true，避免无限等待
            isClient.value = true
        }
    }
    emitter.on('open-pay-type-modal', showVisible)
})

const pay_loading = ref(false)

// 确认支付：将用户选择的支付方式放到第一位，再复用全局下单逻辑
const handleConfirmPay = () => {
    if (!goods_data.value || !selectedPaymentType.value) return

    if (pay_loading.value) return
    pay_loading.value = true

    setTimeout(() => {
        pay_loading.value = false
    }, 2000)
    const payload = {
        ...goods_data.value,
        payment_types: selectedPaymentType.value,
    }

    emitOrderGoods(payload)
    visible.value = false
}

onUnmounted(() => {
    emitter.off('open-pay-type-modal', showVisible)
})

watch(
    () => visible.value,
    newVal => {
        if (!newVal) {
            pay_loading.value = false
            document.body.style.overflow = 'auto'
        } else {
            document.body.style.overflow = 'hidden'
        }
    }
)
</script>

<style scoped lang="less">
/* 自定义动画 */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: scale(0.9);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}

.fixed {
    animation: fadeIn 0.3s ease-out;
}

.recharge-btn {
    background: theme('backgroundColor.active-bg');
}

:deep(.el-loading-mask) {
    background: transparent;
}

.active-pay::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 12px;
    padding: 1px;
    background: linear-gradient(180deg, #c98545 0%, #ffdc82 100%);
    -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    mask-composite: exclude;
    z-index: 1;
}
</style>
